import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Icon = styled.i`
  font-family: 'icons';
  font-size: ${props => (props.big ? '1.2rem' : '1rem')};
  font-style: normal;
  font-variant: normal;
  font-weight: ${'normal'};
  line-height: 1;
  speak: none;
  text-transform: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  &::before {
    content: ${props =>
      props.linkedin
        ? '"\\f0e1"'
        : props.twitter
          ? '"\\f099"'
          : props.instagram
            ? '"\\f16d"'
            : props.github
              ? '"\\f113"'
              : props.firefox
                ? '"\\e902"'
                : props.chrome ? '"\\e900"' : props.opera ? '"\\e901"' : ''};
  }
`;

export default props => <Icon {...props} />;



// WEBPACK FOOTER //
// ./src/components/Icon.js